<template>
  <div class="book_box" @mousemove="handleMove($event)">
    <div
      class="doodles"
      :style="`transform: 
      translate3d(${translationL * 2}px,${translationR * 2}px, 0px);`"
    ></div>
    <div class="book">
      <img
        data-depth="0.2"
        v-for="img in images"
        :key="img"
        :src="img"
        :style="
          'transform:  translateX(-50%)  translate3d(' +
          translationL +
          'px, ' +
          translationR +
          'px, 0px);'
        "
      />
    </div>
    <h1 class="text-center text-white">未来的智慧教科书</h1>
    <p class="text-center subtitle mt-2">智能化、立体化、互动性、自主性</p>
  </div>
</template>

<script>
export default {
  name: '',
  components: {},
  props: [],
  data() {
    return {
      images: [
        require('@/assets/images/courses/book.png'),
        require('@/assets/images/courses/cards.png'),
        require('@/assets/images/courses/dodecahedron.png'),
        require('@/assets/images/courses/snub-dodecahedron.png'),
        require('@/assets/images/courses/variable-1.png'),
        require('@/assets/images/courses/actions.png'),
        require('@/assets/images/courses/die-2.png'),
        require('@/assets/images/courses/trumpet.png'),
        require('@/assets/images/courses/die-1.png'),
        require('@/assets/images/courses/nautilus.png'),
        require('@/assets/images/courses/variable-2.png'),
      ],
      translationL: 0,
      translationR: 0,
    }
  },
  watch: {},
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleMove(e) {
      this.translationL = (e.clientX - window.innerHeight / 2) * 0.02
      this.translationR = (e.clientY - window.innerHeight / 2) * 0.02
    },
  },
}
</script>

<style lang="scss" scoped>
.book_box {
  width: 100%;
  height: auto;
  position: relative;
  will-change: transform;
  background-image: url('../../../assets/images/courses/tiles-1.png'),
    linear-gradient(180deg, #031b3e, #080808);
  background-size: 240px 240px, 100% 100%;
  background-size: contain;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  .doodles {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    will-change: transform;
    background: url('../../../assets/images/courses/doodles.png');
    opacity: 0.1;
    background-size: contain;
  }
  .book {
    position: relative;
    width: 100%;
    height: 30vh;
    max-width: 720px;
    user-select: none;
    pointer-events: none;
    transform-style: preserve-3d;
    backface-visibility: hidden;
    pointer-events: none;
    img {
      position: absolute;
      top: 0;
      left: 50%;
      height: 100%;
      transform-origin: center 65%;
    }
    .first-img {
      position: relative;
    }
  }
  h1 {
    margin: 0;
  }
  .subtitle {
    font-size: 16px;
    color: #6d7382;
  }
}
</style>
